import { Button, ButtonSize, ButtonVariant, Text, TextVariants } from "@next-platform/client-common-spicy-ui";
import React, { memo } from "react";

import Trans from "@/components/Trans/Trans";

type EntriesListEmptyStateProps = {
  message: string;
  hasError: boolean;
  onRetry?: () => void;
};

function EntriesListEmptyState({ message, hasError, onRetry }: EntriesListEmptyStateProps) {
  return (
    <div className="flex flex-col items-center gap-3 py-6" data-testid="EntriesListServer-EmptyState">
      <Text className="text-gray-11 text-center" variant={TextVariants.LABEL_MEDIUM_REGULAR}>
        {message}
      </Text>
      {hasError && onRetry ? (
        <Button variant={ButtonVariant.OUTLINED} size={ButtonSize.MEDIUM} onClick={onRetry} data-testid="EntriesListServer-RetryButton">
          <Trans i18nKey="common:retry" />
        </Button>
      ) : null}
    </div>
  );
}

export default memo(EntriesListEmptyState);
